import { gql } from '@apollo/client';

export const ALL_FRAMEWORKRESULTS_BY_PROGRAMME = gql`
  query AllFrameworkResultsByProgramme($programmeId: ID!) {
    frameworkResults: getFrameworkResultsByProgramme(id: $programmeId) {
      id
      type
      number
      description
      level {
        level
      }
      parentResult {
        id
      }
    }
  }
`;
